// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var PriceRangeCriteria = require("./PriceRangeCriteria.bs.js");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var BuyerNeedPriceRange_buyerNeedV5_graphql = require("../../__generated__/BuyerNeedPriceRange_buyerNeedV5_graphql.bs.js");

var convertFragment = BuyerNeedPriceRange_buyerNeedV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(BuyerNeedPriceRange_buyerNeedV5_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function BuyerNeedPriceRange(props) {
  var buyerNeed = use(props.buyerNeed);
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "price range",
              children: JsxRuntime.jsx(PriceRangeCriteria.make, {
                    priceRange: buyerNeed.priceRange.fragmentRefs,
                    priceType: "oneTime",
                    size: props.size
                  })
            });
}

var make = BuyerNeedPriceRange;

exports.Fragment = Fragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
